export default function R_Mode() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Mode Component</h1>
      <p>This is the R_Mode tutorial section.</p>
    </div>
  );
}
